export const LEGIFRANCE_URL = 'https://www.legifrance.gouv.fr';
export const CONTACT_APPOINTMENT_URL = 'https://livv.eu/tarifs-et-abonnements#rdv';
export const CONTACT_URL = 'https://livv.eu/contactez-nous';

// url accessible for user connected with isPaidCustomer set to false
export const NON_PAID_USER__UNRESTRICTED_URL = ['/profile'];

export const PAID_USER_UNRESTRICTED_URL = ['/search/ai'];

// url not accessible for paid user
export const PAID_USER_RESTRICTED_URL = ['/offer'];
